import React, { PropsWithChildren } from 'react';
import styles from './SubsectionTitle.module.scss';

export function SubsectionTitle({ children }: PropsWithChildren) {
  return <h5 className={styles.subsectionHeading}>{children}</h5>;
}
